// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import browserHistory from 'react-router/lib/browserHistory';
// Components
import OMBaseMultiPinCell from './OMBaseMultiPinCell/OMBaseMultiPinCell';
// Helpers
import parkingConverter from '../../../utils/parkingConverter';
import { trackModalOpen } from '../../../utils/analytics/analyticsManager';
import { getPropertyDetailsPageUrl } from '../../../utils/getDetailsPageUrl';

class OMMultiPinCell extends Component {
  componentDidMount() {
    if (this.multiPinCell) {
      this.multiPinCell.addEventListener('click', this.openDetails, true);
    }
  }

  shouldComponentUpdate(newProps) {
    const isIdChanged = (newProps.id !== this.props.id);
    const isLocaleChanged = (newProps.locale !== this.props.locale);

    return (isIdChanged || isLocaleChanged);
  }

  componentWillUnmount() {
    if (this.multiPinCell) {
      this.multiPinCell.removeEventListener('click', this.openDetails, true);
    }
  }

  openDetails = (evt) => {
    evt.stopPropagation();
    const route = getPropertyDetailsPageUrl(this.props.slug, this.props.locale);

    if (evt.ctrlKey || evt.metaKey) {
      window.open(route);
    } else if (this.props.isMobile) {
      if (this.props.suppressLoading && this.props.setPreloadData) {
        this.props.suppressLoading(true)
          .then(this.props.setPreloadData(this.generatePreloadData()))
          .then(() => browserHistory.push(route));
      } else {
        browserHistory.push(route);
      }
    } else {
      this.openDetailsPopup();
    }
  };

  openDetailsPopup = () => {
    this.props.openDetailsPopup(this.generatePreloadData());
    trackModalOpen(`property/${this.props.id}`);
  };

  generatePreloadData = () => ({
    propertyId: this.props.id,
    slug: this.props.slug,
    address: this.props.addressData,
    price: this.props.price,
    additionalInfo: {
      area: this.props.area,
      floor: this.props.floor === 0
        ? this.props.translate('propertyDetails', 'details', 'groundFloorShortcut').toString()
        : this.props.floor,
      parkingSpots: parkingConverter(this.props.parkingSpots),
      rooms: this.props.rooms
    },
    propertyType: this.props.propertyType,
    optionType: this.props.optionType
  });

  createRef = (ref) => {
    this.multiPinCell = ref;
  };

  render() {
    return (
      <div
        vocab="http://schema.org/"
        typeof="Apartment"
        ref={this.createRef}
      >
        <OMBaseMultiPinCell
          locale={this.props.locale}
          isMobile={this.props.isMobile}
          isRtl={this.props.isRtl}
          id={this.props.id}
          propertyType={this.props.propertyType}
          photo={this.props.photo}
          price={this.props.price}
          address={this.props.address}
          rooms={this.props.rooms}
          parkingSpots={this.props.parkingSpots}
          city={this.props.city}
          area={this.props.area}
          floor={this.props.floor}
          isNewProperty={this.props.isNewProperty}
          hasVRLink={this.props.hasVRLink}
          parkingIconTitle={this.props.translate('iconTitles', 'parkingIcon')}
          roomsIconTitle={this.props.translate('iconTitles', 'roomsIcon')}
          floorIconTitle={this.props.translate('iconTitles', 'floorIcon')}
          squareIconTitle={this.props.translate('iconTitles', 'squareIcon')}
          groundFloorTitle={this.props.translate('propertyDetails', 'details', 'groundFloorShortcut')}
          newPropertyTitle={this.props.translate('iconTitles', 'newPropertyTitle')}
          newPropertyLabel={this.props.translate('iconTitles', 'newPropertyLabel')}
          status={this.props.status}
          translate={this.props.translate}
          propertyEntityType={this.props.propertyEntityType}
          searchOption={this.props.searchOption}
        />
      </div>
    );
  }
}

OMMultiPinCell.propTypes = {
  locale: PropTypes.string,
  isMobile: PropTypes.bool,
  isRtl: PropTypes.bool,
  translate: PropTypes.func,
  className: PropTypes.string,
  id: PropTypes.string,
  photo: PropTypes.string,
  price: PropTypes.number,
  address: PropTypes.string,
  rooms: PropTypes.number,
  parkingSpots: PropTypes.object,
  city: PropTypes.string,
  cityEn: PropTypes.string,
  area: PropTypes.number,
  floor: PropTypes.number,
  addressData: PropTypes.object,
  propertyType: PropTypes.string,
  propertyNote: PropTypes.string,
  isFavorite: PropTypes.bool,
  isPromoted: PropTypes.bool,
  hasVRLink: PropTypes.bool,
  optionType: PropTypes.string,
  isNewProperty: PropTypes.bool,
  addPropertyNote: PropTypes.func,
  toggleFavorite: PropTypes.func,
  onHover: PropTypes.func,
  setPreloadData: PropTypes.func,
  suppressLoading: PropTypes.func,
  openDetailsPopup: PropTypes.func,
  status: PropTypes.string,
  propertyEntityType: PropTypes.string,
  searchOption: PropTypes.string,
  slug: PropTypes.string
};

export default OMMultiPinCell;
